import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Home from "../src/Pages/Home";
import Clearance from "./Pages/Clearance";
import Shop from "../src/Pages/Shop";
import Catalogue from "../src/Pages/Catalogue";
import Contact from "../src/Pages/Contact";
import Header from "../src/Components/Header/Navbar";
import Footer from "../src/Components/Footer/Footer";
import MyAccount from "../src/Pages/MyAccount";

import "./App.css";
import ProductDetails from "./Pages/ProductDetails";
import NotFound from "./Pages/NotFound";
import ScrollToTop from "./Components/ScrollButton/ScrollToTop";
import Authentication from "./Pages/Authentication";
import ResetPass from "./Components/Authentication/Reset/ResetPass";
import TermsConditions from "./Pages/TermsConditions";
import ShoppingCart from "./Components/ShoppingCart/ShoppingCart";
// import Popup from "./Components/PopupBanner/Popup";
import { useDispatch } from "react-redux";
import { LoggedInCheck } from "./Redux/authSlice";
import ProtectedRoute from "./App/ProtectedRoute";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(LoggedInCheck());
  }, [dispatch]);

  return (
    <div>
      <ScrollToTop />
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Shop />} />
          <Route path="/auth" element={<Authentication />} />
          <Route path="/clearance" element={<Clearance />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/catalogue" element={<Catalogue />} />
          <Route
            path="/my-account"
            element={
              <ProtectedRoute>
                <MyAccount />
              </ProtectedRoute>
            }
          />
          <Route path="/product/:productId" element={<ProductDetails />} />
          <Route path="/resetPassword" element={<ResetPass />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/cart" element={<ShoppingCart />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
};

export default App;
